module.exports = __webpack_public_path__ + "img/example-edit-scoreboard.5c0266cd.jpg";